import MxTypography from "@rf-l1/MxTypography";
import React from "react";

const MxDetailSubTitle = ({ label }: { label: string }) => {
  return (
    <MxTypography variant="h6" color="primary.main">
      {label}
    </MxTypography>
  );
};

export default MxDetailSubTitle;
